import(/* webpackMode: "eager", webpackExports: ["MentionsLegalesContent"] */ "/vercel/path0/app/[locale]/(global)/mentions-legales/MentionsLegalesContent.tsx");
